import React from 'react'
import { Breadcrumb, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router'
import { PageLayout } from '../../../components/PageLayout'
import routes from '../../../helpers/routes'
import { createSellOrder } from '../../../utils/api/sellOrders'
import OrderForm from './OrderForm'
import toast from 'react-hot-toast'
import useAuth from '../../../hooks/useAuth'
import { ContactModal } from '../NewSellOrder/ContactModal'

function NewOrder() {
  const { user } = useAuth();
  let history = useHistory<any>();
  const [showContactModal, setShowContactModal] = React.useState(false);
  const [pendingOrder, setPendingOrder] = React.useState<any>(null);

  const createOrder = (order: any) => {
    createSellOrder(order)
      .then(() => {
        toast.success("Orden registrada");
        history.push(routes.orders)
      })
      .catch((e: any) => {
        if (e.response?.data?.code === 'CLIENT_WITHOUT_CONTACTS') {
          setPendingOrder(order);
          setShowContactModal(true);
          return;
        }

        toast.error(e.response?.data?.message || 'Error al crear la orden');
      });
  }

  return (
    <PageLayout>
      <Container>
        <Breadcrumb>
          {user && user.role === 'vendedor' ?
            <Breadcrumb.Item linkProps={{ to: routes.orders }} linkAs={Link}>
              Ordenes
            </Breadcrumb.Item> :
            <Breadcrumb.Item linkProps={{ to: routes.adminOrders }} linkAs={Link}>
              Ordenes
            </Breadcrumb.Item>
          }
          <Breadcrumb.Item active>Nueva Orden</Breadcrumb.Item>
        </Breadcrumb>
        <h1>Nueva Orden de venta</h1>
        <OrderForm submitFunction={createOrder} />
        <ContactModal
          open={showContactModal}
          onClose={() => setShowContactModal(false)}
          customerId={pendingOrder?.customerId}
          onSaved={async () => {
            setShowContactModal(false);
            createOrder(pendingOrder);
          }}
        />
      </Container>
    </PageLayout>
  )
}

export default NewOrder
